import { FormattedMessage } from 'react-intl'

export default function InclusionsTable({ children }) {
  return (
    <div className='items-table'>
      <div className='t-head'>
        <div className='t-cell'>
          <FormattedMessage id='item' defaultMessage='Item' />
        </div>
        <div className='t-cell'>
          <FormattedMessage id='quantity' defaultMessage='Quantity' />
        </div>
        <div className='t-cell'>
          <FormattedMessage id='price' defaultMessage='Price' />
        </div>
      </div>

      { children }
    </div>)
}
